'use client';
import { BLOCKS, INLINES, MARKS, Document, Block, Inline } from '@contentful/rich-text-types';
import { documentToReactComponents, NodeRenderer } from '@contentful/rich-text-react-renderer';
import { LinkRender } from './link-render/link-render';
import EmbeddedEntry from './embedded-entry/embedded-entry';
import EmbeddedAsset from './embedded-asset/embedded-asset';
import BlockquoteRender from './blockquote-render/blockquote-render';

export const richTextRender = (content: Document) => {
    return documentToReactComponents(content, {
        renderMark: {
            [MARKS.CODE]: (text) => {
                return (
                    <code className="before:content-[] after:content-[] bg-[#f5f2f0] text-[#07a] px-2 py-1 text-[90%]">
                        {text}
                    </code>
                );
            },
        },
        renderNode: {
            [INLINES.HYPERLINK]: ((node: Block | Inline) => (
                <LinkRender data={node.data} content={node.content} type="PlainLink" />
            )) as NodeRenderer,
            [INLINES.ASSET_HYPERLINK]: ((node: Block | Inline) => (
                <LinkRender data={node.data} content={node.content} type="AssetLink" />
            )) as NodeRenderer,
            // [INLINES.ENTRY_HYPERLINK]: ({ data }, children) => {
            //     return (
            //         <LinkWrapper page={data['target']}>
            //             <a>{children}</a>
            //         </LinkWrapper>
            //     );
            // },
            [BLOCKS.HEADING_2]: (node, children) => <h2 className="max-w-2xl h-xl container-rich-text">{children}</h2>,
            [BLOCKS.HEADING_3]: (node, children) => <h3 className="max-w-2xl h-lg container-rich-text">{children}</h3>,
            [BLOCKS.HEADING_4]: (node, children) => <h4 className="max-w-2xl h-md container-rich-text">{children}</h4>,
            // quick tips
            [BLOCKS.HEADING_5]: (node, children) => (
                <div className="xl:absolute xl:left-0 xl:max-w-[200px] my-14 xl:my-0 relative text-md w-full mx-auto max-w-2xl font-mono uppercase border-t-2 border-gray-900 pt-2">
                    {children}
                </div>
            ),
            // figcaption for quotes
            [BLOCKS.HEADING_6]: (node, children) => (
                <figcaption className="w-full max-w-2xl mx-auto mt-4 text-xl text-gray-900 mb-14 max-w-container font-headline">
                    {children}
                </figcaption>
            ),
            [BLOCKS.QUOTE]: BlockquoteRender,
            [BLOCKS.PARAGRAPH]: (node, children) => {
                return <p className="max-w-2xl text-xl leading-relaxed container-rich-text">{children}</p>;
            },
            [BLOCKS.UL_LIST]: (node, children) => {
                return <ul className="w-full max-w-2xl mx-auto max-w-container-list">{children}</ul>;
            },
            [BLOCKS.OL_LIST]: (node, children) => {
                return <ol className="w-full max-w-2xl mx-auto max-w-container-list">{children}</ol>;
            },
            [BLOCKS.TABLE]: (node, children) => {
                return <div className="max-w-2xl text-xl leading-relaxed container-rich-text">{children}</div>;
            },
            [BLOCKS.EMBEDDED_ASSET]: EmbeddedAsset,
            // only works for videos.
            // need designs for how other entries would be displayed
            [BLOCKS.EMBEDDED_ENTRY]: EmbeddedEntry,
        },
    });
};
